(() => {
  const pending = window.CozyologyGalleryLookNav?.pending || [];

  const mount = (modal, onNavigate) => {
    if (!modal || typeof onNavigate !== 'function') return;
    const nav = modal.querySelector('[data-gsp-look-nav-root]');
    if (!nav || nav._czGspLookNavMounted) return;
    nav._czGspLookNavMounted = true;
    nav.dataset.gspLookNavMounted = 'true';
    nav.addEventListener('click', event => {
      const button = event.target.closest('[data-gsp-look-direction]');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const direction = Number(button.dataset.gspLookDirection);
      if (direction !== -1 && direction !== 1) return;
      onNavigate(direction, button);
    });
  };

  window.CozyologyGalleryLookNav = { mount };
  pending.forEach(args => mount(...args));
})();
